import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './ItemFooter.css'

/**
 * Item Footer spans the full width at the bottom of an [Item](/components/item/),
 * useful for a row of metadata or trailing actions.
 *
 * @status draft
 * @category list
 * @lightDom true
 *
 * @slot - Default slot for the footer content.
 */
@customElement('nord-item-footer')
export default class ItemFooter extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-item-footer': ItemFooter
  }
}
